import { FormGroup, FormControl } from '@angular/forms';

import 'rxjs/add/operator/map';
declare var $: any;


export class ValidationService {

  emailPattern: string = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$';
  //emailPattern: any = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  //emailPattern: string = '^[a-zA-Z0-9_+&*-]+(?:\\."+"[a-zA-Z0-9_+&*-]+)*@" +"(?:[a-zA-Z0-9-]+\\.)+[a-z" +"A-Z]{2,7}$';
  passwordPattern = '^(?=.*?[a-zA-Z])(?=.*?[@#%$])[a-zA-Z@#%$0-9]{6,15}$';
  // passwordPattern = '^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{6,15}$';
  mobileNumberPattern = '^[0-9+_@#%$]+$';
  numberPattern: string = '^[+0-9]+';
  PasswordMatch(group: FormGroup) {

    let valid = true;
    if (group.controls["ConfirmPassword"].value === group.controls["Password"].value)
      valid = true;
    else
      valid = false;

    if (valid) {
      return null;
    }

    return {
      PasswordMatch: true
    };
  }

  ValidateDropdownList(control: FormControl) {

    let valid = true;
    let selectedValue = parseInt(control.value);
    if (selectedValue !== 0)
      valid = true;
    else
      valid = false;
    if (valid) {
      return null;
    }
    return {
      ValidateDropdownList: true
    };
  }

  ValidateStringValDropdownList(control: FormControl) {

    let valid = true;
    if (control.value !== '' && control.value !== undefined && control.value !== '0')
      valid = true;
    else
      valid = false;
    if (valid) {
      return null;
    }
    return {
      ValidateStringValDropdownList: true
    };
  }

  ValidateMultiCheckDropDown(control: FormControl) {
    let valid = true;
    if (control.value !== '' && control.value !== undefined && control.value !== '0' && control.value !== [])
      valid = true;
    else
      valid = false;
    if (valid) {
      return null;
    }
    return {
      ValidateMultiCheckDropDown: true
    };
  }

  CheckValidEmail(email: string) {
    // return this.emailPattern.match()
  }


}
